var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForgot1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 854.134,
    height: 708,
    viewBox: "0 0 854.134 708",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00a4d6;opacity:0.037;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M854.134,655.475S712.64,782.15,565.357,642.055c-163.366-155.394-73.675-429.832-210.6-437.572S169.135,233.75,81.523,179.021C-20.188,115.485,2.061,0,2.061,0H854.134Z",
    transform: "translate(854.134 708) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgot1);
export default __webpack_public_path__ + "static/media/forgot1.c869ddcb228dff9584ce93c2ab5a9b28.svg";
export { ForwardRef as ReactComponent };